export enum ValidationMessageResponseTypes {
	Question = 1,
	Contradiction = 2,
	Success = 3,
	Warning = 4,
	Error = 5,
}
